import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * HomePage Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const homePageService = (http, cookies) => ({
  /**
   * Get Homepage Data
   *
   * @param {object} param object
   * @param {string} param.platform platform
   */
  async getHomePageData({ platform }) {
    const queryParams = encodeQuery({ platform });
    const data = await http.$get(`${base}/browse/home${queryParams}`);
    return data;
  },

  /**
   * Get HomePage Widget Data
   *
   * @param {object} param object
   * @param {string} param.widgetId widget id
   * @param {number} [param.page] page optional
   * @param {number} [param.limit] limit optional
   */
  async getHomePageWidgetData({ widgetId, page }) {
    const queryParams = encodeQuery({ widgetId, page });
    const { data, pagination } = await http.$get(`${base}/browse/home/more${queryParams}`);
    return { data, pagination };
  },
});
